import { Component, OnInit, ViewChild } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef, DialogService } from 'primeng/dynamicdialog';
import { EmpresasService } from '../../../services/empresas.service';
import { IPromocion } from '../../../interfaces/IPromociones';
import { SwalService } from '@shared/utils/swal.service';
import { Table } from 'primeng/table';
import { AbcEmpresasPromocionesFormComponent } from './abc-empresas-promociones-form/abc-empresas-promociones-form.component';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-abc-empresas-promociones',
  templateUrl: './abc-empresas-promociones.component.html',
  styleUrls: ['./abc-empresas-promociones.component.html'],
  providers: [DialogService]
})
export class AbcEmpresasPromocionesComponent implements OnInit {
  @ViewChild('dt') table!: Table;
  
  loading = false;
  promociones: IPromocion[] = [];
  empresa: string;
  claveEmpresa: string;
  claveSucursal: string;
  nombreSucursal: string;

  columns = [
    { field: 'sEmpresa', header: 'Empresa' },
    { field: 'sSucursal', header: 'Sucursal' },
    { field: 'sPromocion', header: 'Promoción' },
    { field: 'actions', header: 'Acciones' }
  ];

  constructor(
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig,
    private empresasService: EmpresasService,
    private _swalService: SwalService,
    private dialogService: DialogService
  ) {
    if (this.config.data) {
      this.empresa = this.config.data.empresa;
      this.claveEmpresa = this.config.data.claveEmpresa;
      this.claveSucursal = this.config.data.claveSucursal;
      this.nombreSucursal = this.config.data.nombreSucursal;
    }
  }

  ngOnInit(): void {
    this.getPromociones();
  }

  getPromociones(): void {
    this.loading = true;
    const payload = {
      tope: "999",
      sEmpresa: this.claveEmpresa,
      sSucursal: this.claveSucursal,
      sPromocion: ""
    };

    this.empresasService.GetPromocionaut4(payload).subscribe({
      next: (response) => {
        if (response.success) {
          this.promociones = response.data;
        } else {
          this._swalService.error('Error al obtener las promociones');
        }
        this.loading = false;
      },
      error: (error) => {
        console.error('Error al obtener promociones:', error);
        this._swalService.error('Error al obtener las promociones');
        this.loading = false;
      }
    });
  }

  nuevo(): void {
    const ref = this.dialogService.open(AbcEmpresasPromocionesFormComponent, {
      header: 'Nueva Promoción',
      width: '70%',
      data: {
        empresa: this.empresa,
        claveEmpresa: this.claveEmpresa,
        claveSucursal: this.claveSucursal,
        nombreSucursal: this.nombreSucursal
      }
    });

    ref.onClose.subscribe((result: boolean) => {
      if (result) {
        this.getPromociones();
      }
    });
  }

  close(): void {
    this.ref.close();
  }

  delete(row: IPromocion): void {
    Swal.fire({
      title: '¿Está seguro?',
      text: '¿Desea eliminar esta promoción?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'No',
      heightAuto: false,
      customClass: {
        container: 'swal-index',
      },
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        const payload = {
          que: 3,
          tope: "",
          sEmpresa: row.sEmpresa,
          sSucursal: row.sSucursal,
          sPromocion: row.sPromocion
        };

        this.empresasService.DeletePromocion(payload).subscribe({
          next: (response) => {
            if (response.success && response.data.error === 0) {
              this._swalService.success('Promoción eliminada correctamente');
              this.getPromociones();
            } else {
              this._swalService.error('Error al eliminar la promoción');
            }
            this.loading = false;
          },
          error: (error) => {
            console.error('Error al eliminar promoción:', error);
            this._swalService.error('Error al eliminar la promoción');
            this.loading = false;
          }
        });
      }
    });
  }
} 